import React from "react";

const Am = ({ highlighted, status, onClick }) => {
  return (
    <div onClick={onClick} style={{ cursor: "pointer" }}>
      <div
        className="journal-card"
        style={{
          ...(status && { background: "#008CFF" }),
          ...((status || highlighted) && { border: "1px solid #008CFF" }),
          padding: "8px 22px 10px 22px",
        }}
      >
        <h3 className="h6 mb-2">AM Journal</h3>
        <p className="mb-0 text-white-100 d-flex align-items-center gap-2">
          <img src="/icons/stickynote.svg" alt="Sticky Note" />
          {status
            ? "You have completed your AM Journal today."
            : "You have not completed your AM Journal today."}
        </p>
      </div>
    </div>
  );
};

export default Am;
